import CommonAlert from "@/components/CommonAlert";
import useBulkCancelUETDS from "@/providers/hooks/useBulkCancelUETDS";
import { useTrackingActions, useTrackingShowBulkCancelDialog } from "@/stores/use-tracking-table";

function TrackingBulkCancelDialog() {
    const showBulkCancelDialog = useTrackingShowBulkCancelDialog();
    const { handleBulkCancelUETDS, cancelPending } = useBulkCancelUETDS();

    const { updateShowBulkCancelDialog } = useTrackingActions();
    const handleConfirm = async () => {
        if (cancelPending || !showBulkCancelDialog) return;
        await handleBulkCancelUETDS(showBulkCancelDialog.ids);
        handleClose();
    };

    const handleClose = () => {
        updateShowBulkCancelDialog(null);
    };

    return (
        <CommonAlert
            open={!!showBulkCancelDialog}
            loading={cancelPending}
            description="confirmations.bulkUETDSCancel"
            color="error"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                count: showBulkCancelDialog?.ids.length || 0,
            }}
        ></CommonAlert>
    );
}

export default TrackingBulkCancelDialog;
